import { DELIVERY_COMPANIES, getDeliveryCompanyName } from '@/pages/oms/orders/utils/deliveryCompany';

/** Unknown stored codes stay visible, but new choices use the existing OMS list. */
export const deliveryCompanyLabel = (code: string | null | undefined): string =>
  !code || code === 'UNASSIGNED' ? 'Unknown' : getDeliveryCompanyName(code);

/**
 * The select's own name for a company: its Korean name alone, without the OMS code beside it and without a bracketed
 * gloss ("CWAY (Woori Express)" reads CWAY). "CJ대한통운 CJ_DOMESTIC" was cut in the 156px Delivery Company column;
 * the full label is each option's tooltip and the read-only cell still shows it whole (SSD-7674, Yongwon Oct 24).
 */
const selectName = (code: string): string => {
  const company = DELIVERY_COMPANIES.find((c) => c.code === code);
  return company ? company.name.replace(/\s*\(.*\)$/, '') : code;
};

interface DeliveryCompanySelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean | undefined;
}

export function DeliveryCompanySelect({ label, value, onChange, disabled }: DeliveryCompanySelectProps) {
  const known = DELIVERY_COMPANIES.some((company) => company.code === value);
  return (
    <select
      className="form-select form-select-sm delivery-select"
      aria-label={label}
      // The chosen company's full label, OMS code included, as the box's tooltip (SSD-7674).
      title={value ? deliveryCompanyLabel(value) : 'Unknown'}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
    >
      <option value="">Unknown</option>
      {value && !known && (
        <option value={value} title={`${deliveryCompanyLabel(value)} (${value})`}>
          {value}
        </option>
      )}
      {DELIVERY_COMPANIES.map((company) => (
        <option key={company.code} value={company.code} title={getDeliveryCompanyName(company.code)}>
          {selectName(company.code)}
        </option>
      ))}
    </select>
  );
}
